@let $state = state();

@if ($state.loading) {
  <spinner class="app-fill"/>
} @else if ($state.error) {
  <div class="text-bg-danger padded rounded">{{ $state.error }}</div>
} @else {
  @let $pack = pack();
  @let $creating = $state.create;
  @let $items = items();

  <ng-template #settings>
    <div class="field-grid">
      @if ($creating) {
        <label>Name</label>
        <app-editable-text
          [control]="form.controls.name"
          editMode="always"
          placeholder="pack-name"
        />
      }

      <label>Description</label>
      <app-editable-text
        [control]="form.controls.description"
        [editMode]="editMode()"
        placeholder="Pack description"
        (saving)="savePack('description', $event)"
      />

      <label>Visibility</label>
      <app-editable
        [editMode]="editMode()"
        (saving)="savePack('visibility', $event, form.controls.visibility)"
        [valid]="$creating || (form.value['visibility'] != $pack!.visibility)"
        >
        <app-visibility viewContent [value]="form.controls.visibility.value!"/>
        <app-visibility-selector editContent [control]="form.controls.visibility"/>
      </app-editable>

      <label>Version</label>
      <app-editable editMode="never">
        <input type="text" readonly viewContent [value]="$pack?.version || 1">
      </app-editable>
    </div>

    <div class="container">
      <app-editable
        [editMode]="editMode()"
        [valid]="$items && $items.length > 0"
        class="app-fill-parent"
        align="top"
        (editing)="editItems(); $event.focus = search.element()"
        (saving)="updateItems($event)"
        (canceled)="revertItems()"
      >
        <div editContent class="app-column-fill gapped stretched">
          <app-search
            #search
            placeholder="Select items to add..."
            (selected)="addItem($event)"
            [exclude]="$items"
          />

          <div class="app-column bordered rounded scrollable">
            @if ($items && $items.length === 0) {
              <div class="text-secondary padded">No items selected.</div>
            }
            @for (item of $items; track item.id; let i = $index) {
              <app-entity-card [entity]="item">
                <div extra class="app-row">
                  <button type="button" class="transparent" title="Move Up"
                          (click)="moveItem(item, 'up')"
                          [disabled]="i === 0"
                  >
                    <icon type="move_up"/>
                  </button>
                  <button type="button" class="transparent" title="Move Down"
                          (click)="moveItem(item, 'down')"
                          [disabled]="i === $items.length - 1"
                  >
                    <icon type="move_down"/>
                  </button>
                  <button type="button" class="transparent text-danger" title="Remove"
                          (click)="removeItem(item)">
                    <icon type="delete"/>
                  </button>
                </div>
              </app-entity-card>
            }
          </div>
        </div>

        <div viewContent class="scroll-container stretched">
          <app-entity-list [items]="$items" linked="true"/>
        </div>
      </app-editable>
    </div>
  </ng-template>

  <app-page
    [heading]="$pack?.full_name || 'New Pack'"
    [pageTitle]="$pack ? `${$pack.full_name} #${$pack.version} pack` : 'New Pack'"
    pageIcon="pack"
  >
    @if ($creating) {
      <ng-container [ngTemplateOutlet]="settings"/>

      <ng-template pageFooter>
        <app-button type="save" (clicked)="createPack()" [disabled]="form.invalid || $items.length === 0"/>
        <app-button type="cancel" [routerLink]="['..']"/>
      </ng-template>
    } @else {
      <ng-template pageTab="Settings" icon="settings">
        <ng-container [ngTemplateOutlet]="settings"/>
      </ng-template>

      <ng-template pageTab="Usage" icon="usage">
        <app-pack-usage-tab/>
      </ng-template>

      <ng-template pageTab="Preview" icon="preview">
        <app-markdown [content]="previewContent() | async" class="app-fill"/>
      </ng-template>

      <ng-template pageTab="Versions" icon="history">
        Coming soon...
      </ng-template>

      <ng-template pageTab="References" icon="references">
        Coming soon...
      </ng-template>
    }
  </app-page>

}
